import { useMemo } from "react";
import {
  FDR_EXPIRY_DATE_FALLBACK_AVAILABLE,
  FDR_EXPIRY_DATE_FALLBACK_AVAILABLE_PHASE2,
  formatCutoffToLastEligibleDay,
  formatFallbackDay,
} from "./formatFdrExpiry";
import { useBusinessExperimentsById } from "./useBusinessExperimentsById";

export const useFormattedFdrExpiryDate = (): string => {
  const experiment = useBusinessExperimentsById("corp-free-fda");

  return useMemo(() => {
    const fallback =
      experiment?.variant === "available_phase2"
        ? FDR_EXPIRY_DATE_FALLBACK_AVAILABLE_PHASE2
        : FDR_EXPIRY_DATE_FALLBACK_AVAILABLE;

    const formatted =
      experiment?.expirationDate != null
        ? formatCutoffToLastEligibleDay(experiment.expirationDate)
        : undefined;

    return formatted ?? formatFallbackDay(fallback);
  }, [experiment]);
};
